/* Card image dots — SUBTLE overlay. The card's own markup/rendering is untouched;
   dots (and horizontal swipes) swap the primary image's source in place.
   Works on every card system: Dawn cards (.card__media / img.primary-image), the
   collection-cards grid (.ccg-media / .ccg-img) and the homepage tiny-show-pieces grid
   (.tsp-media / .tsp-img). The 2nd/hover image is always .mz-2nd (or .secondary-image
   on Dawn), which we exclude so we only ever swap the PRIMARY image.

   SPEED: every dot image is preloaded+decoded the first time the shopper touches/hovers
   a card, and the swap itself is instant (no artificial delay, no blank flash) — the new
   src is only applied once the browser has it decoded, so switching feels immediate. */
(function () {
  if (window.__ccar2) return;
  window.__ccar2 = true;
  var MEDIA_SEL = '.card__media, .ccg-media, .tsp-media';

  function primaryImg(media) {
    return media.querySelector('img.primary-image')
      || media.querySelector('img:not(.mz-2nd):not(.secondary-image)')
      || media.querySelector('img');
  }

  /* Preload + decode all of a card's dot images once, so the FIRST switch is instant. */
  function preload(media) {
    if (media.__ccarPre) return;
    media.__ccarPre = 1;
    media.querySelectorAll('.ccar__dots i').forEach(function (d) {
      var src = d.getAttribute('data-ccar-src');
      if (!src) return;
      var im = new Image();
      var ss = d.getAttribute('data-ccar-srcset');
      if (ss) im.srcset = ss;
      im.src = src;               // warms the HTTP cache
      if (im.decode) { im.decode().catch(function () {}); }  // and the decode cache
    });
  }

  function setIdx(media, idx) {
    var dots = media.querySelectorAll('.ccar__dots i');
    if (!dots.length) return;
    idx = (idx + dots.length) % dots.length;
    var img = primaryImg(media);
    if (!img) return;
    for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('on', i === idx);
    var d = dots[idx];
    var src = d.getAttribute('data-ccar-src');
    if (!src || img.getAttribute('src') === src) return;
    var ss = d.getAttribute('data-ccar-srcset') || '';
    // Apply only once the target frame is decoded → no blank flash, no artificial delay.
    var pre = new Image();
    if (ss) pre.srcset = ss;
    pre.src = src;
    var apply = function () { if (ss) img.setAttribute('srcset', ss); img.setAttribute('src', src); };
    if (pre.decode) { pre.decode().then(apply).catch(apply); }
    else if (pre.complete) { apply(); }
    else { pre.onload = apply; pre.onerror = apply; }
  }
  function curIdx(media) {
    var dots = media.querySelectorAll('.ccar__dots i');
    for (var i = 0; i < dots.length; i++) if (dots[i].classList.contains('on')) return i;
    return 0;
  }
  window.__ccarStep = function (media, dir) { setIdx(media, curIdx(media) + dir); };

  /* Warm the cache the moment a shopper shows intent on a card (hover on desktop,
     first touch on mobile) — by the time they hit a dot the images are ready. */
  function warm(e) {
    var media = e.target.closest && e.target.closest(MEDIA_SEL);
    if (media && media.querySelector('.ccar__dots')) preload(media);
  }
  document.addEventListener('pointerenter', warm, true);
  document.addEventListener('pointerdown', warm, true);

  document.addEventListener('click', function (e) {
    var dot = e.target.closest && e.target.closest('.ccar__dots i');
    if (!dot) return;
    e.preventDefault();
    e.stopPropagation();
    var media = dot.closest(MEDIA_SEL);
    preload(media);
    setIdx(media, Array.prototype.indexOf.call(dot.parentElement.children, dot));
  }, true);

  /* Horizontal swipe on the image switches too (mobile). */
  var tx = null, ty = null, tm = null;
  document.addEventListener('touchstart', function (e) {
    var media = e.target.closest && e.target.closest(MEDIA_SEL);
    if (!media || !media.querySelector('.ccar__dots')) { tm = null; return; }
    tm = media; tx = e.touches[0].clientX; ty = e.touches[0].clientY;
    preload(media);
  }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (!tm) return;
    var dx = e.changedTouches[0].clientX - tx, dy = e.changedTouches[0].clientY - ty;
    var media = tm; tm = null;
    if (Math.abs(dx) < 40 || Math.abs(dy) > Math.abs(dx)) return;
    window.__ccarStep(media, dx < 0 ? 1 : -1);
  }, { passive: true });
})();
